import {Injectable} from '@angular/core';
import {Validators} from '@angular/forms';
import {abstractForm} from "./abstractForm";

@Injectable({
  providedIn: 'root'
})
export class LoginForm extends abstractForm {

  getForm() {
    return {
      id: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    };
  }

}
